import { useState } from 'react';
import { ApolloError } from '@apollo/client';
import { useSendPushNotificationMutation } from '../../../generated/graphql';
import { SendPushNotificationCommand } from '../types';

export const useNotifications = () => {
  const [error, setError] = useState<Error | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const [sendPushNotification] = useSendPushNotificationMutation();

  const sendNotification = async (input: SendPushNotificationCommand) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await sendPushNotification({
        variables: {
          input
        },
      });

      if (response.errors) {
        throw new Error(response.errors.map(e => e.message).join(', '));
      }

      return response.data?.sendPushNotification;
    } catch (err) {
      const error = err as ApolloError | Error;
      const message = 'graphQLErrors' in error
        ? error.graphQLErrors.map(e => e.message).join(', ')
        : error.message;
      setError(new Error(message));
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    sendNotification,
    isLoading,
    error,
  };
};
